import styled from 'styled-components';

export const CategoryChooserBox = styled.div<{ open: boolean }>`
  position: absolute;
  left: ${props => props.open ? '0px' : '-360px'};
  transition: left 100ms linear;
  top: 0;
  background: #fff;
  z-index: 999999;
  border: 1px solid #ddd;
  border-left: none;
  border-top: none;
  width: 300px;
`;

export const FilterInput = styled.input`
  flex: 1;
  box-sizing: border-box;
  border: none;
  width: 100%;
  padding: 10px;
`;